import { FileUploader, Input, Textarea, ToastMessage } from '@cokitchen/cokitchen-components';
import PageHeaderText from 'components/base/page-header-text';

import SingleBottomNav from 'components/base/single-bottom-nav';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { STORAGE_KEYS } from 'utils/constants';
import { BrandOption, CreateBaseMealType } from 'utils/types';
import SelectBrand from 'components/select-brand';
import { useNavigate } from 'react-router-dom';

const MAX_UPLOAD = 6;

const NewBaseMeal = () => {
  const [imageLimit, setImageLimit] = useState(false);
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN) as string;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ active: false } as CreateBaseMealType);
  const [disabled, setDisabled] = useState(true);
  const [selectedBrand, setSelectedBrand] = useState({} as BrandOption);
  const navigate = useNavigate();

  useEffect(() => {
    setFormData({ ...formData, parent_brand_id: selectedBrand?.value ?? '' });
  }, [selectedBrand]);
  const handleSetImageUrls = (urls: string[]) => {
    if (urls.length === 0) {
      setFormData({
        ...formData,
        images: []
      });
      setImageLimit(false);
      return;
    }

    const allImageUrls = formData?.images?.length ? [...formData.images, ...urls] : urls;

    if (allImageUrls.length > MAX_UPLOAD) {
      setImageLimit(true);
      return;
    }

    setFormData({
      ...formData,
      images: allImageUrls
    });
    setImageLimit(false);
  };
  const formValidity = () => {
    const { name, amount, images, description } = formData;
    if (name === '' || amount === '' || !images || description === '') {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  };
  useEffect(() => {
    formValidity();
  }, [formData]);

  const createBaseMeal = async () => {
    setLoading(true);
    try {
      const res = await apiService.post('base/create-meal', {
        data: formData
      });
      if (res.data) {
        toast(<ToastMessage type='success' message={'Base meal created successfully'} />);
        navigate(-1);
        setFormData({ active: false } as CreateBaseMealType);
      }
    } catch {
      toast(<ToastMessage type='error' message={'Error while creating base meal'} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <PageHeaderText title='Create Base items' description='Provide details for base item' />
      <SelectBrand
        brands={selectedBrand ? [selectedBrand] : []}
        setBrands={([b]) => setSelectedBrand(b)}
      />
      <Input
        className='my-3'
        label='Meal Name'
        placeholder='Enter meal name'
        value={formData.name}
        onChange={(e) => {
          setFormData({
            ...formData,
            name: e.target.value
          });
        }}
      />
      <Textarea
        className='my-1'
        label='Meal Description'
        placeholder='Describe the brand'
        rows={4}
        value={formData.description}
        onChange={(e) => {
          setFormData({
            ...formData,
            description: e.target.value
          });
        }}
      />
      <div className='relative my-3'>
        <Input
          label='Meal Amount'
          type='number'
          placeholder='Enter meal amount'
          pattern='[0-9]*'
          value={formData.amount}
          onChange={(e) => {
            setFormData({
              ...formData,
              amount: e.target.value
            });
          }}
          onWheel={(e) => e.currentTarget.blur()}
        />
        <div className='bg-[#F2F2F3] rounded-md w-[42px] h-[27px] flex justify-center items-center absolute top-12 right-4 z-50'>
          <p className='text-xs'>NGN</p>
        </div>
      </div>
      <Input
        className='my-3'
        label='Meal Available No.'
        placeholder='Enter meal available no.'
        value={formData.available_no}
        onChange={(e) => {
          setFormData({
            ...formData,
            available_no: e.target.value
          });
        }}
      />
      <Input
        className='my-3'
        label='Minimum Age'
        placeholder='Enter minimum age'
        value={formData.minimum_age}
        type='number'
        min={0}
        max={99}
        onChange={(e) => {
          setFormData({
            ...formData,
            minimum_age: e.target.value.toString()
          });
        }}
      />
      <div className='relative'>
        <Input
          className='my-3'
          label='Calories'
          type='tel'
          placeholder='Enter calories'
          value={formData.calories}
          pattern='[0-9]*'
          onChange={(e) => {
            setFormData({
              ...formData,
              calories: e.target.value
            });
          }}
        />

        <div className='bg-[#F2F2F3] rounded-md w-[42px] h-[27px] flex justify-center items-center absolute top-12 right-4 z-50'>
          <p className='text-xs'>KCAL</p>
        </div>
      </div>
      <div className='relative'>
        <Input
          className='my-3'
          label='Meal preparation time'
          type='tel'
          placeholder='Enter duration'
          pattern='[0-9]*'
          value={formData.preparation_time}
          onChange={(e) => {
            setFormData({
              ...formData,
              preparation_time: e.target.value
            });
          }}
        />
        <div className='bg-[#F2F2F3] rounded-md w-[42px] h-[27px] flex justify-center items-center absolute top-12 right-4 z-50'>
          <p className='text-xs'>MINS</p>
        </div>
      </div>

      <div className='my-4 bg-[#F9F6F6] grid grid-cols-2 gap-3 rounded-md border-[0.5px] border-[#EEECEC] px-[20px] py-3'>
        <Input
          type='checkbox'
          label='Sold out? '
          checked={formData.active}
          inputClass='font-medium text-xl'
          onChange={(e) => {
            setFormData({ ...formData, active: e.target.checked });
          }}
        />
      </div>
      <div className='my-8'>
        <FileUploader
          token={token}
          fileUrls={formData?.images?.length ? formData.images : []}
          setFileUrls={handleSetImageUrls}
          label={
            <div className='mb-2'>
              <h3 className='font-medium'>Meal Image (optional)</h3>
              <p className='text-sm text-[#595959]'>Upload up to 6 images</p>
            </div>
          }
          isMultiple
          disabled={formData?.images?.length >= MAX_UPLOAD}
        />
        {imageLimit && (
          <p className='text-sm text-red-5 mb-4'>You cannot upload more than 6 images</p>
        )}
      </div>
      <SingleBottomNav btnDisabled={disabled} loading={loading} onConfirm={createBaseMeal} />
    </div>
  );
};

export default NewBaseMeal;
